import React, {useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { getAllV2Sport, getAllV2Teams } from '../../api/index.js';
import { getUserProvider } from '../../actions/auth.js';
import { Select, Checkbox, CircularProgress, ListItemText, OutlinedInput } from '@mui/material';
import useFetch from '../hooks/useFetch.js';
import SportDTO from '../DTO/SportDTO.js';
import TeamDTO from '../DTO/TeamDTO.js';
import SearchFilterDTO from '../DTO/SearchFilterDTO.js';

export default function SelectTeams({ name, selectedTeams = [], handleChange, disciplines = [] }) {

    const provider = getUserProvider()

    const [searchFilter, setSearchFilter] = useState(new SearchFilterDTO({
        global : {
            provider : provider,
        },
        discipline : { _id : disciplines.map(d => d._id) }
    }))

    const { data, isLoading, error, fetchData} = useFetch(getAllV2Teams, [JSON.stringify(searchFilter)]);

    const [teams, setTeams] = useState([])

    useEffect(() => {
        setSearchFilter(new SearchFilterDTO({
            global : {
                provider : provider,
            },
            discipline : { _id : disciplines.map(d => d._id) }
        }))

    }, [disciplines])

    useEffect(() => {
        fetchData()
    }, [searchFilter])

    useEffect(() => {
        if(!data)
            return

        // Créer la liste de disciplines
        const teamsDTO = data.map(team => new TeamDTO(team))

        setTeams(teamsDTO.sort((a, b) => a.name.localeCompare(b.name)))
    }, [data])

    if(!teams)
        return <CircularProgress />

    const handleSelectChange = (event) => {
        const { value } = event.target;
        const newSelectedTeams = value.map(v =>
            teams.find(d => d._id === v)
        );
        handleChange({target : {value : newSelectedTeams, name}});
    };


    return (
        <FormControl fullWidth>
            <InputLabel>Equipes</InputLabel>
            <Select
                multiple
                name={name}
                label="Equipes"
                value={selectedTeams.map(d => d._id)}
                onChange={handleSelectChange}
                input={<OutlinedInput label="Equipes" />}
                renderValue={(selected) => selected.length > 1 ? 'Plusieurs équipes' : selectedTeams.find(d => d._id === selected[0])?.name}
                MenuProps={{
                getContentAnchorEl: null,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                }
                }}
            >
                {teams.map((team) => (
                        <MenuItem key={team._id} value={team._id}>
                            <Checkbox checked={selectedTeams.some(d => d._id === team._id)} />
                            <ListItemText primary={team.name} />
                        </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}